"use strict";
var Observable_1 = require('../../Observable');
var skipWhile_1 = require('../../operator/skipWhile');
Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
//# sourceMappingURL=skipWhile.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/skipWhile.js